var map = {
	"./background-1152.jpg": "9bc3",
	"./background-1344.jpg": "11f5",
	"./background-1920.jpg": "cbeb",
	"./background-769.jpg": "8140",
	"./background-960.jpg": "df07",
	"./background.jpg": "1100",
	"./brand.svg": "2b3a",
	"./colors.scss": "62d7",
	"./custom.scss": "de82",
	"./feature-1.png": "b460",
	"./fonts.scss": "7929",
	"./fonts/texgyrepagella-bold.otf": "791d",
	"./fonts/texgyrepagella-bolditalic.otf": "49b7",
	"./fonts/texgyrepagella-italic.otf": "ec82",
	"./fonts/texgyrepagella-regular.otf": "75fe",
	"./images/android-chrome-192x192.png": "8b7c",
	"./images/android-chrome-512x512.png": "a3e0",
	"./images/apple-touch-icon.png": "f76b",
	"./images/background-1152.jpg": "a8c8",
	"./images/background-1344.jpg": "0022",
	"./images/background-1920.jpg": "81b5",
	"./images/background-769.jpg": "2cfc",
	"./images/background-960.jpg": "3fa0",
	"./images/district-1800.jpg": "ebac",
	"./images/district-1820.jpg": "6b5b",
	"./images/district-1840.jpg": "1065",
	"./images/district-1860.jpg": "9f05",
	"./images/district-1880.jpg": "4e42",
	"./images/district-1900.jpg": "f6e3",
	"./images/favicon-16x16.png": "d1d3",
	"./images/favicon-32x32.png": "f245",
	"./images/finland-1810.jpg": "c1c5",
	"./images/logo-en.png": "45bb",
	"./images/logo-fi.png": "1467",
	"./images/logo-se.png": "1426",
	"./images/mstile-144x144.png": "4e0a",
	"./images/mstile-150x150.png": "7d38",
	"./images/mstile-310x150.png": "fb57",
	"./images/mstile-310x310.png": "c53f",
	"./images/mstile-70x70.png": "754e",
	"./images/safari-pinned-tab.svg": "3720",
	"./logo-footer-1.svg": "d097",
	"./logo-footer-2.png": "f0b2",
	"./logo-footer-3.jpg": "1efb",
	"./logo-footer.jpg": "364b",
	"./logo.png": "cf05",
	"./material/content": "0b5a",
	"./material/content.json": "0b5a",
	"./material/legend": "07f8",
	"./material/legend.json": "07f8",
	"./search-terms": "2a49",
	"./search-terms.json": "2a49",
	"./variables.scss": "7133"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";